<template>
    <div class="myOrder">
        <div class="order_lists" v-for="(order_item,index) in order_list" :key="index">
            <div class="order_item">
                <p><span>{{$t('order_num')+order_item.order_sn}}</span><span class="order_time">{{timestampToDate(order_item.add_time)}} <i class="fa fa-trash-o" @click="deleteOrder(order_item.order_id)"></i></span></p>
                <div class="item_detail_container" v-for="(good_item,index) in order_item.goods_list" :key="index">
                    <p><span>{{good_item.cat_id_2 | transitionGoodTitle}}</span><span class="uncertain"></span></p>
                    <div class="item_detail">
                        <div class="order_img"><img src="../../assets/images/xuebi_24.png" alt=""></div>
                        <div class="order_info">
                            <h3>{{good_item.goods_name}}<span>X{{good_item.goods_num}}</span></h3>
                            <small>{{$t("use_hour")+handleUseTimeFormat(good_item.occ_date)}}</small>
                            <p><span>￥{{good_item.goods_price}}</span><span v-if="good_item.goods_status==8" class="single_goods_handle_btn" @click="singleGoodsHandleFunc(good_item.cat_id_2,order_item.order_id,order_item.order_sn,good_item.goods_id,good_item.assistcheck,good_item.rec_id,good_item.lock)">{{ good_item.cat_id_2 | transitionGoodsHandleBtn(good_item.lock) }}</span><span v-else class="goodsStatusClass">{{ good_item.goods_status | transitionGoodsStatus }}</span></p>
                        </div>
                    </div>
                </div>
                <p>{{$t("contact_person")+order_item.linkName}} &nbsp;{{order_item.mobile2}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span :class="{redColor: order_item.order_status==3 || order_item.order_status==5 || order_item.order_status==9,greenColor: order_item.order_status==0 || order_item.order_status==1 || order_item.order_status==4 || order_item.order_status==7 || order_item.order_status==8}">{{order_item.order_status | transitionOrderStatus}}</span><span class="grayColor" v-if="order_item.order_status==1 || order_item.order_status==8 || order_item.order_status==9" @click="cancelAnOrder(order_item.order_id)">取消订单</span><span class="orangeColor" v-if="order_item.pay_status == 0 && order_item.order_status == 0" @click="goToPayBtn(order_item.order_sn,order_item.order_id)">去付款</span></p>
                <p><span>{{$t("all_num")+"￥"+order_item.total_amount}}</span><span class="credits"></span></p>
            </div>
        </div>

        <div v-html="infoPage" class="pageListDiv" id="asdf"></div>
    </div>
</template>

<script>
export default {
  name: "myOrder",
  created: function() {
    this.getPersonInfo();
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "my_order");
  },
  inject: ["showMsg"],
  data: function() {
    return {
      order_list: "", //订单列表，数组
      infoPage: "" //分页数据
    };
  },
  mounted: function() {
    setTimeout(() => {
      this.bundleClickEvent();
    }, 1000);
  },
  filters: {
    transitionGoodTitle: function(val) {
      switch (val) {
        case 854:
          return "门票预订";
        case 859:
          return "酒店预订";
        case 848:
          return "年卡预定";
        default:
          return "餐饮预定";
      }
    },
    transitionGoodsStatus: function(val) {
      switch (val) {
        case 0:
          return "待确认";
        case 1:
          return "已确认";
        case 3:
          return "已取消";
        case 4:
          return "已完成";
        case 5:
          return "已作废";
        case 6:
          return "取消中";
        case 7:
          return "已核销";
        case 9:
          return "商品异常";
      }
    },
    transitionGoodsHandleBtn: function(val, lock) {
      switch (val) {
        case 854:
          return "显示核验码";
        case 859:
          return "联系客服";
        case 848:
          if (lock) {
            return "资料填写完毕";
          } else {
            return "上传年卡资料";
          }
        default:
          return "显示核验码";
      }
    },
    transitionOrderStatus: function(val) {
      switch (val) {
        case 0:
          return "待确认";
        case 1:
          return "已确认";
        case 3:
          return "已取消";
        case 4:
          return "已完成";
        case 5:
          return "已作废";
        case 7:
          return "核销中";
        case 8:
          return "下单成功";
        case 9:
          return "下单失败";
      }
    }
  },
  methods: {
    // 利用js获取分页数据并且绑定事件
    bundleClickEvent: function() {
      var DOM = document.getElementById("asdf");
      var a_dom = DOM.getElementsByTagName("a");
      for (var i = 0; i < a_dom.length; i++) {
        var that = this;
        a_dom[i].onclick = function() {
          that.InfoPage(this.dataset.p);
        };
      }
    },
    // 单个商品的操作方法
    singleGoodsHandleFunc: function(
      id,
      order_id,
      order_sn,
      goods_id,
      assistcheck,
      rec_id,
      lock
    ) {
      // 根据id去判断这个商品属于什么分类，根据不同类型的商品再去执行不同的方法
      switch (id) {
        case 854:
          this.showAssistcheck(assistcheck);
          break;
        case 859:
          this.showServiceTel();
          break;
        case 848:
          if (lock) {
            this.yearCardInfoNotModification();
          } else {
            this.goToYearCardInfo(order_id, order_sn, goods_id, rec_id);
          }
          break;
        default:
          this.showAssistcheck(assistcheck);
          break;
      }
    },
    yearCardInfoNotModification: function() {
      layer.open({
        content:
          "年卡资料上传完毕，不可修改。如有需要，请联系客服：0757-27331641/1642",
        btn: "我知道了"
      });
    },
    //酒店商品预定成功后，点击“联系客服”按钮，弹出客服的联系方式
    showServiceTel: function() {
      layer.open({
        content: "客服电话：0757-27331641/1642",
        btn: "我知道了"
      });
    },
    // “门票”或“餐饮”类型商品显示核验码方法
    showAssistcheck: function(assistcheck) {
      layer.open({
        content: "您的核验码为：" + assistcheck,
        btn: "我知道了"
      });
    },
    // 分页方法
    InfoPage: function(p) {
      // console.log(p);
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Order/order_list_ajax?p=" + p,
        dataType: "json",
        data: ""
      })
        .then(res => {
          if (res.data.status === 1) {
            this.getPersonInfoOrderListCb(res.data.result.order_list);
            this.getPersonInfoPageCb(res.data.result.page);
            setTimeout(() => {
              this.bundleClickEvent();
            }, 1000);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    // 请求“我的订单”数据
    getPersonInfo: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Order/order_list_ajax",
        dataType: "json",
        data: ""
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 1) {
            // 处理订单列表
            this.getPersonInfoOrderListCb(res.data.result.order_list);
            // 处理分页数据
            this.getPersonInfoPageCb(res.data.result.page);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 处理订单列表的回调函数
    getPersonInfoOrderListCb: function(data) {
      // console.log(data);
      this.order_list = data;
    },
    // 处理分页的回调函数
    getPersonInfoPageCb: function(data) {
      // console.log(data);
      this.infoPage = data;
    },
    // 将时间戳转化为日期
    add0: function(m) {
      return m < 10 ? "0" + m : m;
    },
    timestampToDate: function(timestamp) {
      var time = new Date(timestamp * 1000);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return (
        y +
        "-" +
        this.add0(m) +
        "-" +
        this.add0(d) +
        " " +
        this.add0(h) +
        ":" +
        this.add0(mm) +
        ":" +
        this.add0(s)
      );
    },
    handleUseTimeFormat: function(time) {
      var formatTime = new Date(time * 1000);
      var formatTimeY = formatTime.getFullYear();
      var formatTimeM = formatTime.getMonth() + 1;
      var formatTimeD = formatTime.getDate();
      formatTime = formatTimeY + "-" + formatTimeM + "-" + formatTimeD;
      return formatTime;
    },
    // 上传年卡资料
    goToYearCardInfo: function(order_id, order_sn, goods_id, rec_id) {
      if (order_id && order_sn) {
        this.$http({
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          method: "post",
          url: this.weburl + this.hurl + "/Order/getUserInfo",
          dataType: "json",
          data: {
            order_id: order_id,
            goods_id: goods_id
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 1) {
              if (res.data.result.lock == 0) {
                this.$router.push({
                  path: "/uploadTheYear",
                  query: {
                    order_id: order_id,
                    order_sn: order_sn,
                    goods_id: goods_id,
                    rec_id: rec_id
                  }
                });
              } else {
                Toast("您目前不能修改年卡资料");
              }
            } else {
              Toast("系统错误,请稍后再试!");
            }
          })
          .catch(err => {
            Toast("系统错误,请稍后再试!");
            console.log(err);
          });
      }
    },
    // 当用户未付款时，点击”去付款“按钮，所触发的方法
    goToPayBtn: function(order_sn, order_id) {
      if (order_sn && order_id) {
        this.$router.push({
          path: "/orderPayChoose",
          query: { order_id: order_id, order_sn: order_sn }
        });
      } else {
        Toast("网络错误，稍后再试");
      }
    },
    // 取消订单的方法
    cancelAnOrder: function(order_id) {
      let that = this;
      layer.open({
        content: "您确定要取消此订单？",
        btn: ["确定", "取消"],
        yes: function(index) {
          if (order_id) {
            that
              .$http({
                xhrFields: {
                  withCredentials: true
                },
                crossDomain: true,
                method: "post",
                url: that.weburl + that.hurl + "/Order/record_refund_order",
                dataType: "json",
                data: {
                  order_id: order_id
                }
              })
              .then(res => {
                // console.log(res);
                if (res.data.status == 1) {
                  Toast("取消成功");
                  setTimeout(() => {
                    that.getPersonInfo();
                  }, 800);
                } else {
                  Toast(res.data.msg);
                }
              })
              .catch(err => {
                Toast("网络错误，请稍后再试");
                console.log(err);
              });
          }
          layer.close(index);
        }
      });
    },
    deleteOrder: function(id) {
      // console.log(id);
      let that = this;
      layer.open({
        content: "您确定要删除此订单？",
        btn: ["确定", "取消"],
        yes: function(index) {
          if (id) {
            that
              .$http({
                xhrFields: {
                  withCredentials: true
                },
                crossDomain: true,
                method: "post",
                url: that.weburl + that.hurl + "/Order/del_order",
                dataType: "json",
                data: {
                  order_id: id
                }
              })
              .then(res => {
                console.log(res);
                if (res.data.status == 1) {
                  Toast("删除成功");
                  setTimeout(() => {
                    that.getPersonInfo();
                  }, 800);
                } else {
                  Toast(res.data.msg);
                }
              })
              .catch(err => {
                Toast("网络错误，请稍后再试");
                console.log(err);
              });
          }
          layer.close(index);
        }
      });
    }
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";
.myOrder {
  width: 100%;
  background: @bg;
  margin-top: 60px;
  .media;
}

.order_item {
  background: #fff;
  padding: 0.5rem 0;
  margin-bottom: @font - 0.2;
  & > p,
  & > .div {
    padding: 0 0.5rem;
  }
  & > p {
    line-height: 28px;
    font-size: @font - 0.2;
    span:first-child {
      margin-right: @font / 2;
    }
    span:last-child {
      float: right;
      &.credits {
        color: @brick_red;
      }
    }
    .order_time {
      color: @word;
      i {
        float: right;
        width: 1.2rem;
        height: 17px;
        margin: 0.3rem 0 0 0.6rem;
        /*   background: url(../../assets/images/xuebi_28.png) no-repeat -5px 0px;
                    background-size: 28px auto;*/
        font-size: @font;
        color: @word;
      }
    }
    .uncertain {
      color: @info;
    }
  }
  & > .item_detail_container > p {
    padding: 0 0.5rem;
    line-height: 28px;
    font-size: @font - 0.2;
    span:first-child {
      margin-right: @font / 2;
    }
    span:last-child {
      float: right;
      &.credits {
        color: @brick_red;
      }
    }
    .uncertain {
      color: @info;
    }
    .uncertainTwo {
      color: red;
    }
  }
  .item_detail {
    .box-sizing;
    padding: 0.6rem;
    height: 90px;
    background: @bg;
    margin-bottom: 0.2rem;
    div {
      float: left;
    }
    .order_img {
      width: 24%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .order_info {
      height: 100%;
      width: 73%;
      margin-left: 3%;
      position: relative;
      h3 {
        font-size: 0.9rem;
        width: 84%;
        .text;
        span {
          position: absolute;
          top: 0;
          right: 0;
          padding: 0 0.2rem;
        }
      }
      small {
        color: @word;
        font-size: 12px;
      }
      p {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        span:first-child {
          color: @subject_color;
          font-size: @font;
        }
        span:last-child {
          float: right;
          a {
            text-decoration: underline;
            color: @word;
            font-size: 0.4rem;
            &:first-child {
              margin-right: 0.5rem;
            }
            &.show_verify,
            &.to_pay,
            &.again {
              text-decoration: none;
              color: #fff;
              font-size: @font - 0.4;
              .border-radius(6px);
            }
            &.show_verify {
              padding: 0.3rem 0.6rem;
              background: @brick_red;
            }
            &.to_pay {
              background: @subject_color;
              padding: 0.3rem 1rem;
            }
            &.again {
              padding: 0.3rem 0.6rem;
              background: @word;
            }
          }
        }
      }
    }
  }
}
.grayColor {
  color: #c2c2c3;
  text-decoration: underline;
}
.orangeColor {
  color: #f27605;
  text-decoration: underline;
}
.redColor {
  color: red;
}
.greenColor {
  color: green;
}
</style>
<style>
.pageListDiv {
  height: 30px;
}
.pageListDiv ul {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pageListDiv ul li {
  color: #4d4d4d;
}
.pageListDiv ul li a {
  display: block;
  background: #bfbfbf;
  width: 16px;
  height: 23px;
  color: #fff;
  font-size: 13px;
  margin: 0 6px;
  text-align: center;
  line-height: 23px;
}
.pageListDiv ul .prev,
.pageListDiv ul .next {
  display: block;
  width: 50px;
  height: 28px;
  border-radius: 6px;
  color: white;
  line-height: 28px;
  font-size: 15px;
}
.single_goods_handle_btn {
  background-color: #7e282e;
  font-size: 13px;
  height: 19px;
  padding-left: 5px;
  padding-right: 5px;
  line-height: 19px;
  text-align: center;
  color: white;
  border-radius: 5px;
}
.goodsStatusClass {
  font-size: 13px;
  text-decoration: underline;
}
</style>
